import { AltTransTrainEvent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { getEventSemantics } from "features/VehicleSidebar/AffectedTrains/utils/utils";
import { FC } from "react";
import { DropsBadge, Text, Tooltip } from "shared/components/Spor";
import styled from "styled-components";

type TrainEventBadgesProps = {
  events: Array<AltTransTrainEvent>;
};

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 3px;
`;

export const TrainEventBadges: FC<TrainEventBadgesProps> = ({ events }) => (
  <Wrapper>
    {events.length ? (
      events.map(({ id, label }) => (
        <Tooltip key={id} hasArrow label={label} placement="top">
          <DropsBadge semantics={getEventSemantics(label)} aria-label={label}>
            {label.length > 14 ? `${label.substring(0, 12)}...` : label}
          </DropsBadge>
        </Tooltip>
      ))
    ) : (
      <Text>Ingen</Text>
    )}
  </Wrapper>
);
